module.exports = __webpack_public_path__ + "media/categories/dsp-icon-63dfa9a1.png";